import axios from 'axios'
import store from '../store/store'

const baseConfig = {
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}

export const jarvisPublicApi = axios.create(baseConfig)

export const jarvisApi = axios.create(baseConfig)
jarvisApi.interceptors.request.use(
  (config) => {
    let user = store.getters.currentUser

    if (user) {
      config.headers['Authorization'] = `Bearer ${user.token}`
    }

    return config
  }
)
jarvisApi.interceptors.response.use(
  response => {
    return response
  },
  error => {
    let errorResponse = error.response
    if (errorResponse.status && (errorResponse.status === 401 || errorResponse.status === 403)) {
      //  disconnect user
      store.dispatch('user/logout', { noRedirect: false, query: { law_firm_id: store.state.lawFirms.selected } })
    }
  }
)
